<script>

import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'

import axios from 'axios'

export default {
  page: {
    title: '360MDR Exclusions - URLs',
    meta: [{ name: 'description', content: appConfig.description }]
  },
  components: {
    Layout,
    PageHeader
  },
  data () {
    return {
      tableBusy: true,
      tableData: [],
      url: '',
      error: false,
      fields: [
        { key: 'address', field: 'url', label: 'URL', control: 'SearchInput', sortable: false, visible: false },
        { key: 'action', label: 'Action', sortable: false, visible: true }
      ],
      title: 'URL Exclusions',
      category: 'List',
      items: [
        {
          text: 'Home',
          href: '/'
        },
        {
          text: 'URL Exclusions',
          active: true
        }
      ],
      appConfig: process.env.NODE_ENV === 'production' ? require('@src/app.config') : require('@src/app.config.dev')
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    loadData () {
      let that = this
      that.isBusy = true
      let baseURL = that.appConfig.xdrAPI.baseURL || 'http://localhost:5000'
      const url = `${baseURL}/auto/exclusion/urls/list`

      axios.get(url)
        .then((response) => {
          that.tableData = response.data.data
          that.tableBusy = false
        })
        .catch(function () {

        })
    },
    showUrlToExclusionListModal () {
      this.$refs['modal-add-exclusion-url'].show()
    },
    validateUrl () {
      const urlPattern = /^[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)$/
      this.error = !urlPattern.test(this.url)
    },
    addUrlToExclusion () {
      this.$refs['modal-add-exclusion-url'].hide()
      const data = {
        address: this.url
      }
      let baseURL = this.appConfig.xdrAPI.baseURL || 'http://localhost:5000'
      const url = `${baseURL}/auto/exclusion/urls/add`
      axios.post(url, data)
        .then(response => {
          console.log('Response:', response.data)
          this.loadData()
        })
        .catch(error => {
          console.error('There was an error!', error)
        })
      console.log('url', this.url)
    },
    removeUrlFromExclusionList (address) {
      let confirmDelete = confirm('Are you sure you want to delete this URL?')
      if (!confirmDelete) {
        return
      }
      const data = {
        address: address
      }
      let baseURL = this.appConfig.xdrAPI.baseURL || 'http://localhost:5000'
      const url = `${baseURL}/auto/exclusion/urls/remove`
      axios.post(url, data)
        .then(response => {
          console.log('Response:', response.data)
          this.loadData()
        })
        .catch(error => {
          console.error('There was an error!', error)
        })
    },
    closeAddUrlToExclusion () {
      this.$refs['modal-add-exclusion-url'].hide()
    }
  }
}
</script>

<template>
  <Layout>
    <PageHeader
      :title="title"
      :items="items"
    />
    <div
      class="container"
      style="max-width: 1420px !important;"
    >
      <div class="row page-title align-items-center" />
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="text-md-right">
              <b-button
                class="btn btn-primary mb-3 ml-auto"
                @click="showUrlToExclusionListModal"
              >
                Add URL to Exclusion List
              </b-button>
            </div>
            <div class="table-responsive mb-0">
              <b-table
                :items="tableData"
                :fields="fields"
                :busy="tableBusy"
                responsive="sm"
                :per-page="0"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :total-rows="totalRows"
                :pagination-options="{
                  enabled: true,
                }"
              >
                <template v-slot:cell(action)="data">
                  <b-dropdown
                    right
                    variant="white"
                    class="align-self-center"
                    toggle-class="p-0"
                  >
                    <template v-slot:button-content>
                      <feather
                        type="chevron-down"
                        class="align-middle"
                        style="height:12px !important;width:20px !important;"
                      />
                    </template>
                    <b-dropdown-item
                      class="notify-item"
                      @click="removeUrlFromExclusionList(data.item.address)"
                    >
                      <feather
                        type="minus-circle"
                        class="icon-dual icon-xs mr-2 align-middle"
                      />
                      <span style="padding-top: 5px;">Remove URL</span>
                    </b-dropdown-item>
                  </b-dropdown>
                </template>
                <template v-slot:table-busy>
                  <div class="text-center">
                    <br><br>
                    <b-spinner class="align-middle" />
                    <strong>&nbsp;&nbsp;Loading...</strong>
                  </div>
                </template>
              </b-table>
            </div>
          </div>
        </div>
      </div>
      <b-modal
        id=""
        ref="modal-add-exclusion-url"
        size="md"
        title="Add URL to Exclusion List"
        :ok-only="false"
        :centered="true"
        :no-fade="true"
        @ok="handleOk"
      >
        <div class="row">
          <div class="col-md-12">
            <div class="form-group mb-1">
              <label>URL</label>
              <input
                id="address"
                v-model="url"
                type="text"
                class="form-control"
                placeholder="example.com or example.com/path"
                @input="validateUrl"
              >
            </div>
          </div>
        </div>
        <template v-slot:modal-footer>
          <b-button
            variant="secondary"
            @click="closeAddUrlToExclusion"
          >
            Cancel
          </b-button>
          <b-button
            variant="primary"
            :disabled="error"
            @click="addUrlToExclusion"
          >
            OK
          </b-button>
        </template>
      </b-modal>
    </div>
  </Layout>
</template>

<style>
.even-row {
  background-color: #f9f9f9;
}

.odd-row {
  background-color: #ffffff;
}
</style>
